export enum ClaimsEnum {
    blcfullaccess = 'BLCFullAccess',
    blcexceptions = 'BLCExceptions',
    blcreadonly = 'BLCReadOnly'
}
